<template>
  <transition name="bounce">
    <b-container class="py-5 custom-container container">
      <h2 class="pl-0 pt-5 mt-5 font-weight-bold">File Request</h2>
      <h3 class="pl-0 mt-5 font-weight-bold">Template Section</h3>
      <p class="pl-0 text-secondary">
        Select from the template request you want to send or create new from
        scratch.
      </p>
      <b-row class="ml-auto">
        <b-col :md="3" :cols="6">
          <b-card class="first" @click="newFilePage">
            <b-img-lazy
              center
              :src="require('@/assets/icons/add.png')"
            ></b-img-lazy>
            <b-card-body class="text-center">
              <b-card-title class="font-weight-bold">New Request</b-card-title>

              <b-card-text class="text-secondary">
                Create without a template
              </b-card-text>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col
          :md="3"
          :cols="6"
          class="mb-4"
          v-for="template in templates"
          :key="template.id"
        >
          <template-item
            :template="template"
            @click="showSendRequestModal(template)"
          />
        </b-col>
      </b-row>
      <send-request-modal
        :showModal="showModal"
        :template="selectedTemplate"
        @sendRequestResponse="sendRequestResponse"
        @closeModal="showModal = false"
      />
      <b-alert
        class="custom-alert"
        :show="dismissCountDown"
        :class="{
          'bg-danger border-danger': alertType === 'danger',
        }"
        dismissible
        fade
        :variant="alertType"
        @dismiss-count-down="countDownChanged"
      >
        {{ alertMsg }}
      </b-alert>
    </b-container>
  </transition>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import TemplateItem from '../templates/TemplateItem'
import SendRequestModal from '@/components/modals/SendRequestModal'

export default {
  components: {
    TemplateItem,
    SendRequestModal,
  },
  data() {
    return {
      loading: false,
      showModal: false,
      selectedTemplate: {
        id: null,
        name: '',
      },
      dismissCountDown: 0,
      alertMsg: null,
      alertType: 'primary',
    }
  },
  computed: {
    ...mapGetters('template', ['templates']),
  },
  methods: {
    ...mapActions('template', ['getTemplates']),
    async fetchTemplates() {
      this.loading = true
      try {
        await this.getTemplates()
      } catch (e) {
        this.$bvToast.toast('Could not load templates. Please try again.', {
          variant: 'danger',
          title: 'Error',
        })
      } finally {
        this.loading = false
      }
    },
    newFilePage() {
      this.$router.replace({ name: 'request.new-page' })
    },
    showSendRequestModal(template) {
      this.selectedTemplate.id = template.id
      this.selectedTemplate.name = template.label
      this.showModal = true
    },
    async sendRequestResponse(res) {
      if (res.success) {
        this.alertMsg =
          'File request shared successfully to selected emails: ' +
          res.data.success.join(', ')

        this.dismissCountDown = 15
        // Same pattern as NewRequestForm.vue's non-edit success path -
        // let the success alert show briefly, then land somewhere that
        // shows the result instead of leaving the user on the template
        // picker with no visible outcome.
        setTimeout(
          () =>
            this.$router.push({ name: 'requests.list-page' }).catch(() => {}),
          1500,
        )

        return
      } else {
        this.alertType = 'danger'

        if (res.status === 402 || res.status === 422) {
          if (res.message) {
            this.alertMsg = res.message
          } else {
            this.alertMsg = 'File shared unsuccessful!'
          }
        } else {
          this.alertMsg =
            'Something went wrong while submitting the share file email!'
        }
      }

      this.dismissCountDown = 5
      this.clearAlert()
    },

    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },

    clearAlert() {
      this.dismissCountDown = 0
      this.alertMsg = null
      this.alertType = 'primary'
    },
  },
  mounted() {
    this.fetchTemplates()
  },
}
</script>
<style lang="scss" scoped>
.card {
  width: 342px;
  height: 342px;
  cursor: pointer;

  &:hover {
    background: #eaf3ff 0% 0% no-repeat padding-box;
    box-shadow: 0px 10px 25px #00429d0d;
  }

  @media (max-width: 767px) {
    width: 173px;
    height: 175px;

    img {
      width: 74px;
      height: 74px;
    }

    .card-body {
      padding-top: 0.5rem;
      padding-left: 0.25rem;
      padding-right: 0.25rem;
      padding-bottom: 0.5rem;
    }

    .card-title {
      font-size: 1rem;
    }

    .card-text:last-child {
      font-size: 0.9rem;
      line-height: 15px;
    }
  }
}
.first {
  background: #ebedf095;
}
</style>
